$(document).ready(function () {
  let popularAddOnTimer = setInterval(() => {
    const addOnsContainer = $(".new-pdp-popular-add-ons-carousel");
    const widgetProperties = {
      _attribution: "Rebuy Product Add-Ons",
      _source: "Rebuy",
      _widget_id: newPdpAddOnsWidgetId,
    };

    const addOnsInput = $(
      "#new_pdp_add_to_cart_form input[name='add-ons-products']"
    );
    let swiper;
    if (addOnsContainer.length) {
      swiper = new Swiper(".new-pdp-popular-add-ons-carousel", {
        slidesPerView: "auto",
        spaceBetween: 12,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });

      const tagsDom = $(".new-pdp-popular-add-ons-carousel [data-tag]");
      const tags = [];
      let orderFlag = false;
      for (const tagDom of tagsDom) {
        const tag = $(tagDom).attr("data-tag");
        if (tag == "") orderFlag = true;
        else if (!tags.some((_tag) => _tag === tag)) tags.push(tag);
      }
      if (orderFlag) tags.push("Other");

      if (tags.length) {
        $("#add-ons-tabs-list").html(
          tags.reduce((tagDom, tag, index) => {
            if (index === 0) {
              const activeTags = addOnsContainer.find(
                `.swiper-slide[data-tag='${tag}']`
              );
              activeTags.show();
              if (activeTags.length === 1) {
                activeTags.removeClass("!w-[322px]");
              }
              addOnsContainer.find(`.swiper-slide[data-tag!='${tag}']`).hide();
              swiper.update();
            }
            return `${tagDom}<button
                class="text-[13px] px-4 py-0.5 rounded-full font-medium mr-1.5 border border-[#dde2e9] ${
                  index ? "text-[#012970]" : "bg-[#034dd1] text-white"
                }"
              >${tag}</button>`;
          }, "")
        );
      }

      $("#add-ons-tabs-list button").click(function () {
        const btn = $(this);
        btn
          .addClass("bg-[#034dd1] text-white")
          .removeClass("text-[#012970]")
          .siblings()
          .removeClass("bg-[#034dd1] text-white")
          .addClass("text-[#012970]");
        const tag = btn.text();
        const activeTags = addOnsContainer.find(
          `.swiper-slide[data-tag='${tag}']`
        );
        activeTags.show();
        if (activeTags.length === 1) {
          activeTags.removeClass("!w-[322px]");
          activeTags.find(".add-ones-name-part").css("padding-left", "50px");
        }
        addOnsContainer.find(`.swiper-slide[data-tag!='${tag}']`).hide();
        swiper.update();
      });

      //   auto add function
      const autoAddDoms = $(
        ".new-pdp-popular-add-ons-carousel [data-auto-add-id]"
      );
      const autoAddIds = [];
      if (add_to_cart_method == "later") {
        for (const autoAddDom of autoAddDoms) {
          const productId = $(autoAddDom).attr("data-auto-add-id");
          autoAddIds.push(productId);
          $(autoAddDom).find("input").prop("checked", true);
        }
      }
      addOnsInput.val(
        JSON.stringify(
          autoAddIds.map((id) => ({
            id,
            quantity: 1,
            properties: widgetProperties,
          }))
        )
      );

      function addOnsToggleToCart(productId, _this) {
        if (add_to_cart_method == "later") {
          toggleToPrepareCart(
            $(_this).attr("data-product-id"),
            $(_this).is(":checked")
          );
        }
        if (add_to_cart_method == "directly") {
          const isChecked = $(_this).is(":checked");
          if (isChecked)
            addToCart(
              productId,
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              widgetProperties
            ).then(() => {
              $(".new-pdp-popular-add-ons-carousel .prepare-to-cart").prop(
                "checked",
                false
              );
            })
            .catch((error) => {
              console.error("Error adding product to cart:", error);
            })
          else {
            Rebuy.SmartCart.items().forEach((item) => {
              if (item.id === productId) {
                Rebuy.SmartCart.decreaseItem(item);
              }
            });
          }
        }
      }
      window.addOnsToggleToCart = addOnsToggleToCart;

      function toggleToPrepareCart(id, isAdd = true) {
        addOnsProducts = JSON.parse(addOnsInput.val());
        if (isAdd) {
          addOnsProducts.push({
            id,
            quantity: 1,
            properties: widgetProperties,
          });
        } else {
          addOnsProducts = addOnsProducts.filter(
            (product) => product.id !== id
          );
        }
        addOnsInput.val(JSON.stringify(addOnsProducts));
      }
      $("#new_pdp_add_to_cart_form button").click(function () {
        $(".new-pdp-popular-add-ons-carousel .prepare-to-cart").prop(
          "checked",
          false
        );
        setTimeout(() => {
          $("#new_pdp_add_to_cart_form input[name='add-ons-products']").val(
            "[]"
          );
        }, 3000);
      });

      clearInterval(popularAddOnTimer);
      popularAddOnTimer = null;
    }
  }, 100);
});
